export default __webpack_public_path__ + "static/media/C1.61dc2442.svg";